import { CommentActionErrors } from '@comments/store/enums/comment-action-errors';

export const COMMENT_ERRORS_MAP = new Map<string, CommentActionErrors>([
    ['Add_Comment_Failure', CommentActionErrors.CommentCreation],
    ['Update_Comment_Failure', CommentActionErrors.CommentUpdate],
    ['Listing_Removed_Error', CommentActionErrors.ListingRemovedError]
]);